// --------------------------------------------------------------
// Created On: 2021-05-14
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./InlineEllipsisSpinner.module.scss";

// Inline ellipsis spinner that lets the user know something is loading.
export default function InlineEllipsisSpinner(props: Props): Component {
  return props.loading ? (
    <div className={styles.inlineSpinnerContainer} data-test="inline-ellipsis-spinner">
      <div role="status" className={styles.spinner} />
    </div>
  ) : null;
}

interface Props {
  loading: boolean;
}
